<template>
  <slot 
    v-bind="{ 
      addProduct,
      changeProductAmountInOrder,
      changeProductCustomAmountInOrder,
      getPreviousProductInOrderData,
      removeProductFromOrder,
    }"
  />
</template>

<script>
import { mapGtmItemsFromOrder, createDeepClone, trackECommerceEvent, createGtmItemFromProduct } from '../../gtm'
let currentProductId = null
let previousQuantity = 0

export default {
  props: {
    currency: String,
    products: Array,
    getProducts: Function,
  },
  computed: {
    gtmItems() {
      return mapGtmItemsFromOrder(
        createDeepClone(this.products),
        'order', 
      )
    },
  },
  methods: {
    changeProductAmountInOrder(productId, amount) {
      let event = null
      if (amount === 0) {
        return
      } else if (amount > 0) {
        event = 'add_to_cart'
      } else if (amount < 0) {
        event = 'remove_from_cart'
      }

      let gtmItem = this.gtmItems.find(item => item.item_id == productId)
      gtmItem.quantity = Math.abs(amount)

      if (!gtmItem.price) {
        return
      }

      trackECommerceEvent(
        [gtmItem],
        this.currency,
        gtmItem.price,
        event, 
      )
    },
    addProduct(product) {
      const gtmProduct = createGtmItemFromProduct(
        product,
        'order'
      )

      trackECommerceEvent(
        [gtmProduct],
        this.currency,
        gtmProduct.price,
        'add_to_cart', 
      )
    },
    removeProductFromOrder(productId) {
      let gtmItem = this.gtmItems.find(item => item.item_id == productId)

      trackECommerceEvent(
        [gtmItem],
        this.currency, 
        gtmItem.price * gtmItem.quantity,
        'remove_from_cart', 
      )
    },
    getPreviousProductInOrderData(productId) {
      currentProductId = productId
      previousQuantity = this.gtmItems.find(item => item.item_id == productId).quantity
    },
    changeProductCustomAmountInOrder() {
      this.$nextTick(() => {
        const gtmItems = mapGtmItemsFromOrder(createDeepClone(this.getProducts()), 'order')
        let gtmItem = gtmItems.find(item => item.item_id == currentProductId)
        const delta = gtmItem.quantity - previousQuantity
        
        if (delta === 0) { 
          return
        }

        gtmItem.quantity = Math.abs(delta)

        trackECommerceEvent(
          [gtmItem],
          this.currency, 
          gtmItem.price * gtmItem.quantity,
          delta > 0 ? 'add_to_cart' : 'remove_from_cart',
        )
      })
    },
  }
}
</script>
